<template>
<div class="home" :style="{backgroundImage:bgImg?bgImg:''}">
    <div class="admin" @click="tagClick">
        {{userName&&userName!='null'&&userName!=null?userName:phone?phone:''}}
        <ul class="adminBox" v-if="isTrue">
            <li @click="passwd">修改密码</li>
            <li @click="outLogin">退出登录</li>
        </ul>
    </div>
    <div class="desc">
        <div class="name">{{homeFile.title?homeFile.title:'四川省雪亮工程云平台'}}</div>
        <div class="content">雪亮工程”是以县、乡、村三级综治中心为指挥平台、以综治信息化为支撑、以网格化管理为基础、以公共安全视频监控联网应用为重点的“群众性治安防控工程”.它通过三级综治中心建设把治安防范措施延伸到群众身边,发动社会力量和广大群众共同监看视频监控,共同参与治安防范,从而真正实现治安防控“全覆盖、无死角”.因为“群众的眼睛是雪亮的”,所以称之为“雪亮工程.</div>
    </div>
    <div class="box" style="text-align: center">
        <!-- <img style="height: 100%;z-index: -1;transform:scale(.6)" src="../../../assets/images/home/yuan.png"> -->
        <div class="mainContent">
                <div class="chunk" @click="filterPower('1')">
                    <div class="iconfont iconshipin"></div>
                    <div class="designation">
                        <div class="chineseName">视频监控</div>
                        <!-- <p class="fabien">video surveillance</p> -->
                    </div>
                </div>
                <div class="chunk" @click="filterPower('2')">
                    <div class="iconfont iconshipintonghua1"></div>
                    <div class="designation">
                        <div class="chineseName">可视对讲</div>
                        <!-- <p class="fabien"> Visual intercom</p> -->
                    </div>
                </div>
                <div class="chunk" @click="filterPower('3')">
                    <div class="iconfont iconbimicons-"></div>
                    <div class="designation">
                        <div class="chineseName">指挥中心</div>
                        <!-- <p class="fabien">command center</p> -->
                    </div>
                </div>
                <div class="chunk" @click="filterPower('4')">
                    <div class="iconfont icontongjifenxi"></div>
                    <div class="designation">
                        <div class="chineseName">云图分析</div>
                        <!-- <p class="fabien"> Data visualization</p> -->
                    </div>
                </div>
                <div class="chunk" @click="filterPower('5')">
                    <div class="iconfont iconPC1"></div>
                    <div class="designation">
                        <div class="chineseName">时空地图</div>
                        <!-- <p class="fabien">Geographic Information System</p> -->
                    </div>
                </div>
                <div class="chunk" @click="filterPower('6')">
                    <div class="iconfont iconshezhi"></div>
                    <div class="designation">
                        <div class="chineseName">系统设置</div>
                        <!-- <p class="fabien">System Settings</p> -->
                    </div>
                </div>
        </div>
    </div>
    <div class="foot">
        <span class="foot-box" v-if="unitData&&unitData.undertakeUnit"> 承办单位: {{unitData.undertakeUnit}}</span>
        <span class="foot-box" v-if="unitData&&unitData.constructionUnit"> 建筑单位: {{unitData.constructionUnit}}</span>
        <span class="foot-box" v-if="unitData&&unitData.supportUnit"> 技术支持单位: {{unitData.supportUnit}}</span>
    </div>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="修改密码" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="旧密码" prop="oldPwd">
                <el-input type="password" v-model="ruleForm.oldPwd"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
                <el-input type="password" v-model="ruleForm.newPwd"></el-input>
            </el-form-item>

            <el-form-item label="确认新密码" prop="confirmPad">
                <el-input type="password" v-model="ruleForm.confirmPad"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
let Base64 = require('js-base64').Base64;
import {
    districtApi,
    cameraApi
} from '../../../api-path/district-api.js'
import {
    loginApi
} from '../../../api-path/login-api'
export default {
    name: "home",
    data() {
        return {
            bgImg: "url(" + require("../../../assets/images/login/bg1.jpg") + ")",
            homeFile:{},
            isTrue: false,
            ruleForm: {
                oldPwd: '', //旧密码
                newPwd: '', //新密码
                confirmPad: '', //确认新密码
            },
            dialogVisible: false,
            userName: localStorage.getItem('p') || '',
            phone: localStorage.getItem('phone') || '',
            unitData: null,
            permissionList: [],
            rules: {
                oldPwd: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'change'
                }, ],
                newPwd: [{
                    required: true,
                    validator: this.padverify,
                    trigger: 'change'
                }],
                confirmPad: [{
                    required: true,
                    validator: this.padverify2,
                    trigger: 'change'
                }],
            }
        }
    },
    created() {

        this.permissionList = JSON.parse(localStorage.getItem('ur')).sourceTreeDTOList[0].sourceTreeDTOList;
        this.$http.get(`${districtApi.findUnitById}/${JSON.parse(localStorage.getItem('ur')).areaId}`).then(res => {
            if (res.status === 200) {
                this.unitData = res.result;
            }
        })
        // this.$http.get(cameraApi.codeAndItem).then(res => {
        //     if (res.status === 200) {
        //         localStorage.setItem('codeData', JSON.stringify(res.result))
        //     }
        // })
        this.homeFile=JSON.parse(localStorage.getItem('homeFile'));
        this.bgImg=this.homeFile.indexImg?'url(' + this.homeFile.indexImg + ')':"url(" + require("../../../assets/images/login/bg1.jpg") + ")"
    },
    methods: {
        tagClick() {
            this.isTrue = !this.isTrue;
        },
        padverify(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                var regu = "^[0-9a-zA-Z]{6,20}$";
                var re = new RegExp(regu);
                if (!re.test(value)) {
                    callback(new Error('必须为6-16位字母或数字'));
                } else {
                    callback();
                }
            }
        },
        padverify2(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入确定密码'));
            } else {
                if (value == this.ruleForm.newPwd) {
                    callback();
                } else {
                    callback(new Error('两次输入密码不一致!'));

                }

            }
        },
        filterPower(inx) {
            switch (inx) {
                case "1":
                    // if (this.authorityJudge('', false)) {
                      if (typeof window.QCefClient !== 'undefined') {
                        window.QCefClient.invokeMethod('QCEF_OPEN_CAMERA_DIALOG')
                      }
                    // } else {
                    //     this.$message.error('无权限访问视频监控')
                    // }
                    break;
                case "2":
					if (this.authorityJudge('/visual-intercom', true)) {
						sessionStorage.removeItem('active')
						this.$router.push('/visual-intercom')
					} else {
						this.$message.error('无权限访问可视对讲')
					}
                    break;
                case "3":
                    if (this.authorityJudge('/command', true)) {
						sessionStorage.removeItem('active')
                        this.$router.push('/command')
                    } else {
                        this.$message.error('无权限访问指挥中心')
                    }
                    break;
                case "4":
                    if (this.authorityJudge('/cloud-picture', true)) {
						if (typeof window.QCefClient !== 'undefined') {
							let href=window.location.origin+'/#/cloud-picture'
							window.QCefClient.invokeMethod('QCef_Open_Web_Dialog',href,'云图分析')
						}else{
							let {href}=this.$router.resolve({
								name:'cloud-picture'
							})
							window.open(href, '_blank');
						}
                    } else {
                        this.$message.error('无权限访问云图分析')
                    }
                    break;
                case "5":
                    if (this.authorityJudge('/GIS', true)) {
						if (typeof window.QCefClient !== 'undefined') {
							let href=window.location.origin+'/#/GIS'
							window.QCefClient.invokeMethod('QCef_Open_Web_Dialog',href,'时空地图')
						}else{
							let {href}=this.$router.resolve({
								name:'GIS'
							})
							window.open(href, '_blank');
						}
                    } else {
                        this.$message.error('无权限访问时空地图')
                    }
                    break;
                case "6":
                    if (this.authorityJudge('/system-settings', true)) {
						sessionStorage.removeItem('active')
                        this.$router.push('/system-settings')
                    } else {
                        this.$message.error('无权限访问系统设置')
                    }
                    break;
                default:
            }

        },
        authorityJudge(url, isTrue) {
            let arr = this.permissionList.filter((item) => {
                return item.code == url && item.isThisSystem == isTrue
            })
            if (arr.length > 0) {
                return true
            }
            return false
        },
        passwd() {
            this.dialogVisible = true;
        },
        outLogin() {
            this.$http.get(loginApi.logOut).then(res => {
                if (res.status === 200) {
					this.$store.commit('setIsBreakIM',true)
					window.websock.close();
					this.$store.commit('setAlarmId','');
					this.$store.commit('clearLoginInfo');
                    this.$router.push('/login')
                }
            })
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs['ruleForm'].resetFields();
        },
        submitForm(formName) {
          this.ruleForm.oldPwd=Base64.encode(this.ruleForm.oldPwd);
          this.ruleForm.newPwd=Base64.encode(this.ruleForm.newPwd);
          this.ruleForm.confirmPad=Base64.encode(this.ruleForm.confirmPad);

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.get(loginApi.newPwd, {
                        params: this.ruleForm
                    }).then(res => {
                        if (res.status == 200) {
                            this.$message.success('修改密码成功');
                            sessionStorage.clear();
                            localStorage.clear();
                            this.$router.push('/login')
                        }
                    })
                } else {
                    return false;
                }
            });
        },

    }
}
</script>

<style lang="less">
@import "./home.less";
</style>
